export * from './next-icon.component';